import React from 'react'

const Footer = () => {
    return (
        <>
            {/* Footer Start */}
            <footer className="bg-light text-center py-4 border-top">
                <div className="container">
                    <h5 className="text-dark mb-3">Contact Info</h5>
                    <p className="mb-2">
                        <i className="fa fa-map-marker me-2 text-primary" />
                        #1, Sri Thirumal Nager, Nadukuthagai, Chennai - 602 024
                    </p>
                    <p className="mb-2">
                        <i className="fas fa-envelope me-2 text-primary" />
                        <a
                            href="mailto:akconsultancy19@gmail.com"
                            className="text-decoration-none text-dark"
                        >
                            akconsultancy19@gmail.com
                        </a>
                    </p>
                    <p className="mb-2">
                        <i className="fa fa-phone me-2 text-primary" />
                        <a href="tel:+919176507631" className="text-decoration-none text-dark">
                            +91 91765 07631
                        </a>
                    </p>
                    <p>
                    <i className="fas fa-mobile me-2 text-primary" />
                        <a href="tel:+919600098389" className="text-decoration-none text-dark">
                            +91 96000 98389
                        </a>
                    </p>
                </div>
            </footer>
            {/* Copyright Start */}
            <div className="bg-dark text-white text-center py-3">
                <p className="mb-0">
                    ©{" "}
                    <a href="#" className="text-white fw-bold text-decoration-none">
                        Ackn.in
                    </a>
                    . All rights reserved.
                </p>
                <p className="mb-0">
                    Designed by{" "}
                    <a
                        href="https://nicknameinfotech.com"
                        className="text-white text-decoration-underline"
                    >
                        Nickname Infotech
                    </a>
                </p>
            </div>
            {/* Back to Top Button */}
            <a
                href="#"
                className="btn btn-primary rounded-circle back-to-top position-fixed bottom-0 end-0 m-4 shadow"
            >
                <i className="fa fa-arrow-up" />
            </a>
            {/* JavaScript Libraries */}
            {/* Template Javascript */}
        </>
    )
}

export default Footer